<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
        <vs-card>
          <div slot="header">
            <h3 class="card-title mb-0">Información de filtro</h3>
          </div>
          <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <!-- Selector de empresa -->
              <company-selector v-model="companyId"/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Fecha inicial *</label>
              <vs-input type="date" v-model="initialDate" class="w-100"/>
            </vs-col>

            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Fecha final *</label>
              <vs-input type="date" v-model="finalDate" class="w-100"/>
            </vs-col>
          </vs-row>
          <br/>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Tipo Vehículo</label>
              <multiselect v-model="selectedVehicleType" placeholder="Seleccione tipo de vehículo" label="name"
                           track-by="code" :options="showVehiclesTypes" :multiple="true"
                           :taggable="true" :max-height="150" :max="50">
              </multiselect>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Filtros</label>
              <multiselect v-model="selectedIncomeType" placeholder="Seleccione para filtrar" label="name"
                           track-by="code" :options="showIncomeTypes" :multiple="true"
                           :taggable="true" :max-height="150" :max="50">
              </multiselect>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Unidades de tiempo *</label>
              <multiselect v-model="interval" placeholder="Seleccione unidad de tiempo" label="name"
                           track-by="id" :options="intervalTypes" :multiple="false"
                           :taggable="true" :max-height="150" :max="50">
              </multiselect>
            </vs-col>
          </vs-row>
          <hr class="custom-hr"/>
          <div class="d-inline-block d-md-flex align-items-center">
            <div class="btn-alignment">
              <vs-button @click="searchData()">Buscar</vs-button>
              <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
            </div>
            <div class="ml-auto mt-3 mt-md-0">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                  <vs-button class="btnx" type="filled" color="danger" @click="downloadReport()">
                    <i class="ti-upload mr-2"></i>Exportar
                  </vs-button>
                  <vs-dropdown>
                    <vs-button class="btn-drop" type="filled" color="danger"
                               icon="expand_more"></vs-button>
                    <vs-dropdown-menu>
                      <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                 :value="document.id" :key="document.id"
                                 :id="document.id" @click="formatType=document.id">{{ document.name }}
                      </vs-button>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-col>
    <!-- Inicio Panel linea de tiempo -->
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12" v-if="isEnablePreview">

      <vs-card>
        <h3 class="card-title d-flex">
          Línea de tiempo {{ interval.name }} frecuencia parqueadero
          <vs-button class="ml-auto p-0" @click="lineareachart = true" type="line">
          </vs-button>
        </h3>
        <div>
          <analyticChart :options-obj="chartOptions" :series-list="series"/>
        </div>
      </vs-card>
      <div>
      </div>
    </vs-col>
    <!-- Fin Panel linea de tiempo -->
    <!-- Inicio de tabla de datos -->
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12" v-if="isEnablePreview">
      <vs-card>
        <h3 class="card-title d-flex">
          Tabla de búsqueda
          <vs-button class="ml-auto p-0" @click="statetable = true" type="line">
          </vs-button>
        </h3>
        <div class="border" style="max-height: 43em;
              overflow-y: auto;">
          <vs-table :data="dataListFront">
            <template slot="thead">
              <vs-th v-for="columns in dataColumns">
                {{ columns.columns }}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="dataInfo in dataListFront" :key="dataInfo.id">
                <vs-td v-for="dataNew in dataInfo">{{ dataNew.value }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </vs-col>
    <!-- Fin de tabla de datos -->
  </vs-row>
</template>

<script>
import {ROUTES} from "@/global/api_routes";
import GenericMovement from "@/views/overview-report/page/generic-movement";
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import multiselect from "vue-multiselect";
import analyticChart from "@/views/overview-report/reports/analytic-chart/analytic-chart.vue";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";
import toast from "@/global/ToastConfig";
import DateUtils, {FORMATS} from "@/global/DateUtils";
import IncomeSpecialEndpoints from "@/endpoints/income/IncomeSpecialEndpoints";
import VehicleEndPoint from "@/endpoints/core/VehicleEndPoint";

export default {
  name: "parking-frequency",
  components: {analyticChart, multiselect, CompanySelector, GenericMovement},
  data() {
    return {
      companyId: null,
      initialDate: null,
      finalDate: null,
      interval: null,
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      intervalTypes: [
        {name: "1 hora", id: "60 minute", minute: 60},
        {name: "2 horas", id: "120 minute", minute: 120},
        {name: "4 horas", id: "240 minute", minute: 240},
      ],
      intervalDetail: [
        {name: "15 minutos", id: "15 minute", minute: 15},
        {name: "30 minutos", id: "30 minute", minute: 30},
      ],
      detailNames: ["15 minutos", "30 minutos"],
      objSeriesList: [],
      timeGraphicList: [],
      isEnablePreview: false,
      minutesFront: 0,
      isLoading: false,
      texto: null,
      dataListFront: [],
      dataColumns: [],
      viewHours: null,
      viewMinutes: null,
      minutes: 0,
      hours: 0,
      series: [],
      chartOptions: {},
      selectedIncomeType: [],
      showIncomeTypes: [],
      showVehiclesTypes: [],
      selectedVehicleType: [],
      isRotation: false,
      isMonthly: false,
      listMonthlyTypes: null,
    }
  },
  mounted() {
    this.getMonthlyType();
    this.getVehicleTypes();
  },
  watch: {
    interval() {
      this.clearObject();
      this.isEnablePreview = false;
    },
    companyId() {
      this.isEnablePreview = false;
      this.clearObject();
    },
    initialDate() {
      this.interval = null;
      this.isEnablePreview = false;
      this.clearObject();
      this.validateRanges();
    },
    finalDate() {
      this.isEnablePreview = false;
      this.clearObject();
      this.validateRanges();
    },
    selectedIncomeType(){
      this.isEnablePreview = false;
      this.clearObject();
    },
    selectedVehicleType(){
      this.isEnablePreview = false;
      this.clearObject();
    }
  },

  methods: {
    /**
     * Método para sumar dias a una fecha parametro
     * @param finalDate
     * @returns {*|string}
     */
    addDateDays(finalDate) {
      const newDate = DateUtils.addDays({
        date: finalDate, amount: 1
      });
      return DateUtils.parseForced({date: newDate, format: FORMATS.DATE_SHORT});
    },
    /**
     * metodo que limpia el formulario
     */
    clearForm() {
      this.initialDate = null;
      this.finalDate = null;
      this.companyId = null;
      this.interval = null;
      this.isEnablePreview = false;
      this.listMonthlyTypes = null;
      this.selectedVehicleType = [];
      this.selectedIncomeType = [];
      this.clearObject();

    },
    /**
     * Metodo que valida mis parametros en la interfaz grafica
     * para no hecer peticiones erroneas al servidor
     * @returns {Promise<void>}
     */
    async validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
      if (!this.interval) {
        throw new Error("Seleccione intervalo de tiempo");
      }
    },
    /**
     * valida la diferencia entra la fecha inicial y la final para habilitar o no el intervalo de 15 y 30 minutos
     */
    validateRanges() {
      DateUtils.differenceInDays(this.initialDate, this.finalDate) > 31 ?
          this.detailNames.forEach((name) => {
            const index = this.intervalTypes.findIndex((obj) => obj.name === name);
            if (index !== -1) {
              this.intervalTypes.splice(index, 1);
            }
          })
          : this.intervalDetail.forEach((obj) => {
            const exist = this.intervalTypes.find((objt) => objt.name === obj.name);
            if (!exist) {
              this.intervalTypes.push(obj);
            }
          })
    },
    /**
     * Método que valida los filtros de la consulta si se quiere que traiga rotacion o mensualidades o ambas
     * @returns {Promise<void>}
     */
    async getValidateFilters() {
      if (this.selectedIncomeType.length > 0) {
        if (this.selectedIncomeType.some(obj => obj.name === 'Rotativo')) {
          this.isRotation = true;
          this.listMonthlyTypes = this.deleteRotation(this.selectedIncomeType);
        } else {
          this.isRotation = false;
          this.listMonthlyTypes = this.joinList(this.selectedIncomeType);
          this.isMonthly = true;
        }
      } else {
        this.isRotation = false;
        this.listMonthlyTypes = this.deleteRotation(this.showIncomeTypes);
        this.isMonthly = false;
      }
    },
    /**
     * Elimina el rotativo de la lista de filtro
     * @param list
     * @returns {*}
     */
    deleteRotation(list) {
      var listWithoutRotative = [];
      var listEmpty = [];
      listEmpty.push({name: 'Vacio', code: 0})
      listWithoutRotative = list.filter(obj => obj.name !== 'Rotativo');
      if (listWithoutRotative.length > 0) {
        this.isMonthly = true
        return this.joinList(listWithoutRotative)
      }
      this.isMonthly = false
      return this.joinList(listEmpty);
    },
    /**
     * Método para unir los objetos  de la lista por coma
     * @param list
     * @returns {*}
     */
    joinList(list) {
      return list.map(item => item.code).join(",");
    },
    /**
     * metodo que valida si seleccionaron un tipo de vehiculo o si no que tenga encuenta todos los tipos
     * @returns {Promise<*>}
     */
    async getValidateVehicles() {
      return this.selectedVehicleType.length === 0
          ? this.joinList(this.showVehiclesTypes)
          : this.joinList(this.selectedVehicleType)
    },
    /**
     * Metodo que trae la informacion para mostrar en la interfaz
     * @returns {Promise<void>}
     */
    async searchData() {
      try {
        await this.validateForm();
        this.isLoading = true;
        this.getValidateFilters();
        const params = await this.prepareParameters();
        parkingReportsEndpoints.previewParkingFrequency(params)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              if (data.code === 0) {
                this.isLoading = false;
                return;
              }
              const dataJson = JSON.parse(data.info);
              this.processDataTable(dataJson);
              this.isLoading = false;
            });
      } catch (error) {
        toast.error(error);
        this.isLoading = false;
      }

    },
    /**
     * metodo que prepara los parametros de consulta
     * @returns {{finalDate: (*|string), companyId: null, interval, initialDate: string}}
     */
    async prepareParameters() {

      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate
        }),
        finalDate: this.addDateDays(this.finalDate),
        interval: this.interval.id,
        typeVehicle: await this.getValidateVehicles(),
        typeMonthly: this.listMonthlyTypes,
        isRotary: this.isRotation,
        isMonthly: this.isMonthly,
      }
    },
    /**
     * Método que tiene la logica para pintar la data en la  tabla y grafica resultado de la búsqueda
     * @param data data encontrada del endpoint
     */
    processDataTable(data) {
      this.minutesFront = this.interval.minute;
      const amount = 1440 / this.minutesFront;
      this.clearObject();
      data.forEach(info => {
        this.buildCellData(info, amount);
      });
      data.forEach(info => {
        this.prepareSeriesGraphic(info, amount);
      });
      this.buildColumns(amount);
      this.isEnablePreview = true;
      this.isLoading = false;
    },

    /**
     * Método que contruye la celda de la información
     * @param info data encontrada por los criterios
     * @param amount partiones de la de la tabla
     */
    buildCellData(info, amount) {
      const dataList = [];
      /** Primera celda por defecto */
      dataList.push({
        value: info['day_date']
      }, {
        value: info['type_record'] === "I" ? "Ingresos" : "Salidas"
      });
      /** Siguientes columnas hasta amount */
      for (let i = 1; i <= amount; i++) {
        dataList.push({
          value: info['col' + i]
        });
      }
      let sum = 0;
      for (let i = 2; i < dataList.length; i++) {
        sum += dataList[i].value;
      }
      dataList.push({
        value: sum
      });
      /** agregar a la lista para mostrar*/
      this.dataListFront.push(dataList);
    },
    /**
     * metodo que arma los objetos con las frecuencias de todas las fechas
     * @param info
     * @param amount
     */
    prepareSeriesGraphic(info, amount) {
      const valuesList = [];
      for (let i = 1; i <= amount; i++) {
        valuesList.push(
            info['col' + i]
        );
      }
      const objSeries = {
        data: valuesList,
        name: info['type_record'] === "I" ? "Ingresos" : "Salidas",
      }
      this.objSeriesList.push(objSeries);
      this.setSeriesGraphic(this.objSeriesList);
    },
    /**
     * metodo que suma las frecuencias de todas las fechas del rango para graficar
     * @param list
     */
    setSeriesGraphic(list) {
      this.series = list.reduce((accumulator, obj) => {
        const objAccumulated = accumulator.find((accumulated) => accumulated.name === obj.name);
        objAccumulated ? objAccumulated.data = objAccumulated.data.map((value, index) => value + obj.data[index])
            : accumulator.push({...obj});
        return accumulator;
      }, []);

    },
    /**
     * envio de datos de la grafica  en el eje x
     * @param list
     * @returns {{dataLabels: {enabled: boolean}, xaxis: {categories, type: string, labels: {style: {cssClass: string}}}, legend: {show: boolean}, grid: {borderColor: string, show: boolean}, tooltip: {x: {format: string}, theme: string}, markers: {size: number}, chart: {toolbar: {show: boolean}}, stroke: {curve: string, width: number}, yaxis: {labels: {style: {cssClass: string}}}, colors: string[]}}
     */
    setOptionsGraphic(list) {
      this.chartOptions = {
        dataLabels: {
          enabled: false
        },
        chart: {
          toolbar: {
            show: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        colors: ['#2962FF', '#4fc3f7', '#f62d51', '#ffbc34', '#212529'],
        xaxis: {
          type: 'time',
          categories: list,
          labels: {
            style: {
              cssClass: 'text-muted fill-color',
            }
          },
        },
        yaxis: {
          labels: {
            style: {
              cssClass: 'text-muted fill-color',
            }
          },
        },
        markers: {
          size: 3,
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          },
          theme: 'dark',
        },
        legend: {
          show: true
        },
        grid: {
          show: true,
          borderColor: 'rgba(0,0,0,0.1)',

        }
      }
    },

    /**
     * Método que construye las columnas de la tabla
     * @param amount cantidad de columnas
     */
    buildColumns(amount) {
      this.chartOptions = {};
      this.timeGraphicList = [];
      /** Primera celda por defecto */
      this.dataColumns.push({
            columns: 'Fecha '
          },
          {
            columns: 'Tipo '
          });
      /** Siguientes columnas hasta amount */
      for (let i = 0; i < amount; i++) {
        if (i === 0) {
          this.roundTime();
          continue;
        }
        this.minutes += this.minutesFront;
        this.calculateTime();
        this.roundTime();
      }
      // envio de datos  a el xaxis de la grafica
      this.setOptionsGraphic(this.timeGraphicList);
      this.dataColumns.push({
        columns: 'Total '
      });
    },

    /**
     * Limpiar datos grafica y tabla
     */
    clearObject() {
      this.dataListFront = [];
      this.dataColumns = [];
      this.objSeriesList = [];
      this.series = [];
      this.timeGraphicList = [];
      this.minutes = 0;
      this.hours = 0;
    },

    /**
     * Cáclular el time de acuerdo a sus número de columnas
     */
    calculateTime() {
      if (this.minutes >= 60) {
        if (this.minutesFront < 60) {
          this.hours += 1;
          this.minutes = this.minutes % 60;
          return;
        }
        let valueMin = this.minutes;
        while (valueMin >= 60) {
          this.hours = this.hours + 1;
          valueMin -= 60;
        }
        this.minutes = this.minutes % 60;
      }
    },

    /**
     * Redondear el time de la columna
     */
    roundTime() {
      this.viewHours = this.hours;
      this.viewMinutes = this.minutes;
      if (this.hours < 10) {
        this.viewHours = "0" + this.hours;
      }
      if (this.minutes < 10) {
        this.viewMinutes = "0" + this.minutes;
      }
      // se envia los encabezados  a la lista para la grafica en eje x
      this.timeGraphicList.push(this.viewHours + ":" + this.viewMinutes)
      // se envia los encabezados  a la lista para la tabla
      this.dataColumns.push({
        columns: this.viewHours + ":" + this.viewMinutes
      });
    },
    /**
     * Método de descarga de reporte
     * @returns {Promise<void>}
     */
    async downloadReport() {
      try {
        await this.validateForm();
        this.isLoading = true;
        toast.info("Cargando reporte");
        await this.getValidateFilters();
        const params = await this.prepareParameters();
        parkingReportsEndpoints.downloadParkingFrequency(params)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              a.download = urlFile;
              a.click();
              this.isLoading = false;
            })
      } catch (error) {
        toast.error(error);
        this.isLoading =false;
      }
    },
    /**
     * Método que obtiene los tipos de mensualidad
     */
    getMonthlyType() {
      IncomeSpecialEndpoints.listIncomeSpecialTypes()
          .then(data => {
            if (data.code <= 0) {
              toast.error(data.message);
              return;
            }
            toast.ok(data.message);
            data.info.forEach((monthly) => {
              const unity = {
                name: monthly.title,
                code: monthly.code,
              };
              this.showIncomeTypes.push(unity);
            });
            this.showIncomeTypes.push({
              name: "Rotativo",
              code: 1
            })
          })
    },
    /**
     * metodo que lista los tipos de vehiculo que pertenezcan a la compañia ingresada
     * @returns {Promise<void>}
     */
    async getVehicleTypes() {
      try {
        this.showVehiclesTypes = [];
        this.isLoading = true;
        VehicleEndPoint.getListGeneral()
            .then(data => {
              if (data.code === 0) {
                this.isLoading = false;
                return;
              }
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              data.info.forEach((vehicle) => {
                const unity = {
                  name: vehicle.title,
                  code: vehicle.code,
                };
                this.showVehiclesTypes.push(unity);
              });
            });
        this.isLoading = false;
      } catch (error) {
        toast.error(error.message);
      }
    },
  }
  ,

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
